export default __webpack_public_path__ + "static/media/Black-Pattern.01484fd8.png";